import {
	GunListEmptyState,
	GunListSkeleton,
	Tile,
	Tiles,
} from '@gov-nx/component/web';
import type { ServiceCode } from '@gov-nx/module/service';
import { useZbrojniListSeznamContext } from '@gov-nx/module/service';
import { ServiceContentLayout } from '@gov-nx/ui/web';
import { LowLoaMessage } from '../../../Auth/LowLoaMessage';
import { useLocale } from '@gov-nx/core/service';
import { serviceRouteResolver } from '@gov-nx/web';

type ListViewProps = {
	code: ServiceCode;
};

export const GunListView = ({ code }: ListViewProps) => {
	const { t } = useLocale(code);
	const { strings, isCrzResultLoading, hasCrzResult, loginInfo } =
		useZbrojniListSeznamContext();

	if (loginInfo.isLowLoa) {
		return <LowLoaMessage content={t('stav.varovani.low-loa')} />;
	}

	if (isCrzResultLoading) {
		return <GunListSkeleton />;
	}

	if (!hasCrzResult) {
		return <GunListEmptyState code={code} />;
	}

	return (
		<ServiceContentLayout>
			<h2 className="gov-text--headline-m">{strings.title}</h2>
			<p>{strings.subtitle}</p>
			<Tiles>
				<Tile
					title={t('zbrojni-list.seznam.uplny.nadpis')}
					to={`${serviceRouteResolver('zbrojni-list')}/uplny`}>
					<p className="mt-0! text-(--text-primary)">
						{t('zbrojni-list.seznam.uplny.popis')}
					</p>
				</Tile>
			</Tiles>
		</ServiceContentLayout>
	);
};
